//import * as SignalR from '@aspnet/signalr';
import { Store } from 'redux';
import { DialogConfig } from './../../common/models/DialogConfig';
//import { TargetTypeEnum } from 'inversify';
import { IAuthProvider } from '../../common/providers/DialogAuthProvider';
import { LegacySignalRProvider } from '../providers/LegacySignalRProvider';
import { bool } from 'prop-types';

export interface ISignalRService { }

export class DialogSignalRService implements ISignalRService {
    //private readonly _connection: SignalR.HubConnection;
    private readonly _legacySignalRProvider: LegacySignalRProvider;
    public constructor(
        private _store: Store,
        private _config: DialogConfig,
        private _authProvider: IAuthProvider) {
            this._legacySignalRProvider = new LegacySignalRProvider(this._config, this._store, this._authProvider);
    }
    public initialize() {
        this._legacySignalRProvider.initialize();
    }
    public close() {
        this._legacySignalRProvider.close();
    }
    public changeTab(id: string, sequence: number) {
        this._legacySignalRProvider.changeTab(id, sequence);
    }
    public search(tabId: string, text: string) {
        this._legacySignalRProvider.search(tabId, text);
    }
    public setFilter(tabId: string, filters: any[]) {
        this._legacySignalRProvider.setFilter(tabId, filters);
    }
    public setReadLater(messageId: number, value: boolean) {
        this._legacySignalRProvider.setReadLater(messageId, value);
    }
    public showMore(tabId: string, lastActivityId: number, pageNumber: number) {
        this._legacySignalRProvider.showMore(tabId, lastActivityId, pageNumber);
    }
    public deleteMessage(id: number) {
        this._legacySignalRProvider.deleteMessage(id);
    }
    public addComment(parentIds: number[], comment: string) {
        this._legacySignalRProvider.addComment(parentIds, comment);
    }
    public deleteComment(ids: number[]) {
        this._legacySignalRProvider.deleteComment(ids);
    }
    public addLike(parentIds: number[], like: boolean) {
        this._legacySignalRProvider.addLike(parentIds, like);
    }
}